import { render } from "./ScanningView.vue?vue&type=template&id=354556ac&scoped=true"
const script = {}

import "./ScanningView.vue?vue&type=style&index=0&id=354556ac&lang=scss&scoped=true"

import exportComponent from "/home/lw8dl1214/actions-runner/_work/AIPR-Frontend/AIPR-Frontend/haleon-ar-detector/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354556ac"]])

export default __exports__